import { ChevronLeft } from 'lucide-react'

export interface LayoutAppProps{
  children: React.ReactNode
  header: {
    title: string
    backButton?: boolean
    onBack?: () => void
    rightButton?: {
      text: string
      onClick: () => void
    }
  }
}

export function LayoutApp({ children, header }: LayoutAppProps){
  return(
    <div className="min-h-svh bg-gray-50">
      {/* iOS-style Header */}
      <header className="sticky top-0 z-50 bg-white/85 backdrop-blur-ios border-b border-ios shadow-ios">
        {/* Safe area top padding for mobile */}
        <div className="pt-safe">
          <div className="h-16 flex items-center justify-between px-4 relative">
            {/* Left side - Back button */}
            <div className="flex items-center justify-start w-20">
              {header.backButton && (
                <button 
                  onClick={header.onBack}
                  className="flex items-center space-x-1 text-ios-blue ios-button-press -ml-1 py-1 px-1"
                >
                  <ChevronLeft size={18} strokeWidth={2.5} />
                  <span className="text-[17px] font-normal">Voltar</span>
                </button>
              )}
            </div>
            
            {/* Center - Title */}
            <div className="absolute left-1/2 transform -translate-x-1/2">
              <h1 className="text-gray-900 text-[17px] font-semibold truncate max-w-48 text-center leading-snug">
                {header.title}
              </h1>
            </div>
            
            {/* Right side - Optional action button */}
            <div className="flex items-center justify-end w-20">
              {header.rightButton && (
                <button 
                  onClick={header.rightButton.onClick}
                  className="text-ios-blue text-[17px] font-normal ios-button-press py-1 px-1"
                >
                  {header.rightButton.text}
                </button>
              )}
            </div>
          </div>
        </div>
      </header>
      
      {/* Content */}
      <main className="flex-1 mt-5 px-4">
        {children}
      </main>
    </div>
  )
}